<template>
<div class="chapter">
<div class="inner_page">
<p class="space"> </p>
<p class="copyright3"><a id="page_iv"></a><a id="Copyright">Copyright © Geirr H Haarr 2010</a></p><a id="Copyright">
<p class="copyright3">First published in Great Britain in 2010 by<br/>
Seaforth Publishing,<br/>
Pen &amp; Sword Books Ltd,<br/>
47 Church Street,<br/>
Barnsley S70 2AS</p>
</a><p class="copyright3"><a id="Copyright"></a><a href="http://www.seaforthpublishing.com" target="_blank">www.seaforthpublishing.com</a></p>
<p class="copyright3"><i>British Library Cataloguing in Publication Data</i><br/>
A catalogue record for this book is available from the British Library</p>
<p class="copyright3">ISBN 978 1 84832 057 4<br/>
EPUB ISBN: 978 1 78346 905 5<br/>
PRC ISBN: 978 1 78346 672 6</p>
<p class="copyright3">All rights reserved. No part of this publication may be reproduced or transmitted in any form or<br/>
by any means, electronic or mechanical, including photocopying, recording, or any information<br/>
storage and retrieval system, without prior permission in writing of both the copyright owner and<br/>
the above publisher.</p>
<p class="copyright3">The right of Geirr H Haarr to be identified as the author of this work has been asserted by him in<br/>
accordance with the Copyright, Designs and Patents Act 1988.</p>
<p class="copyright3">Typeset and designed by JCS Publishing Services Ltd, <a href="http://www.jcs-publishing.co.uk" target="_blank">www.jcs-publishing.co.uk</a><br/>
Printed and bound in Great Britain by the MPG Books Group</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Copyright.vue?30f168e0